import { ErrorHandler, Injectable, Injector } from '@angular/core';

import { LogsService } from '../services/http-client/logs.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error) {
    const maintenanceService = this.injector.get(LogsService);
    if (maintenanceService) {
      const message = !error.message && !error.stack ? error.toString() : error.message;
      maintenanceService.saveWebExceptionLog(message, error.stack).subscribe(() => {});
    }
    throw error;
  }
}
